import { ChartLegendComponent } from "./charts/components/chart-legend/chart-legend.component";
import { SeriesListComponent } from "./charts/components/chart-series/chart-series-list.component";
import { ChartComponent } from "./charts/components/charts/chart.component";
import { TimeRangeComponent } from "./charts/components/time-range.component/chart-time-range.component";
import { ChartTabsComponent } from "./charts/components/chart-tabs/chart-tabs.component";

import { NumberComponent } from "./numbers/number.component";
import { AnomaliesComponent } from "./anomalies/anomalies.component";
import { NewsComponent } from "./news/news.component";
import { NewsListComponent } from "./news/newslist.component";

// anticipate the register of components to prevent Bundler tree shaking issue
const registerComponents = () => {
  customElements.define('tbw-chart', ChartComponent)
  customElements.define('tbw-chart-legend', ChartLegendComponent)
  customElements.define("tbw-chart-series", SeriesListComponent)
  customElements.define("tbw-chart-time-range", TimeRangeComponent)
  customElements.define('tbw-number', NumberComponent)
  customElements.define('tbw-anomalies', AnomaliesComponent)
  customElements.define('tbw-news', NewsComponent)
  customElements.define('tbw-chart-tabs', ChartTabsComponent)
  customElements.define('tbw-news-list', NewsListComponent)
  console.log('components registered')
}

const init = () => {
  console.log('init')
  registerComponents()
}
init()